import styled, { css } from 'styled-components'

export const StyledDivider = styled.div`
    margin-top: 15px;
    margin-bottom: 15px;
    width: 100%;
    height: 1px;
    background-color: ${ ({ theme }) => theme.veryLightPink};
    ${({ vertical }) =>
        vertical &&
        css`
           width: 1px; 
           height: 100%;
        `
    };
    ${({ noMargin }) =>
        noMargin &&
        css`
           margin: 0;
        `
    };
`